import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

type Input = { step: string };

function GetStepLastExecutionHeader({
  toolUse,
  result,
  interrupted,
}: ToolUseProps) {
  const input = toolUse.input as Input | undefined;
  const stepName = input?.step;
  const done = !!result && !result.isError;

  if (done && !stepName) {
    return <ToolStatus icon="circle-slash" text="Step not found" />;
  }

  const text = stepName
    ? done
      ? `Got execution for ${stepName}`
      : `Getting execution for ${stepName}…`
    : "";
  return (
    <ToolStatus icon="history" text={text} pending={!done && !interrupted} />
  );
}

function GetStepLastExecutionBody({ toolUse, result }: ToolUseProps) {
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const getStepLastExecution: ChatTool = {
  name: "getStepLastExecution",
  Header: GetStepLastExecutionHeader,
  Body: GetStepLastExecutionBody,
};
